import { ImageSourcePropType } from 'react-native';

export type AvatarOption = {
  id: string;
  source: ImageSourcePropType;
  color: string;
};

export const avatarOptions: AvatarOption[] = [
  { id: 'avatar/1.png', source: require('../../assets/avatar/1.png'), color: '#FFD447' },
  { id: 'avatar/2.png', source: require('../../assets/avatar/2.png'), color: '#39BFFF' },
  { id: 'avatar/3.png', source: require('../../assets/avatar/3.png'), color: '#FF9F1C' },
  { id: 'avatar/4.png', source: require('../../assets/avatar/4.png'), color: '#5DDA7C' },
  { id: 'avatar/5.png', source: require('../../assets/avatar/5.png'), color: '#FF5CA8' },
];

const legacyAvatarMap: Record<string, ImageSourcePropType> = {
  'aural-user-avatar.png': require('../../assets/aural-user-avatar.png'),
  'aural-author-1.png': require('../../assets/aural-author-1.png'),
  'aural-author-2.png': require('../../assets/aural-author-2.png'),
  'aural-author-3.png': require('../../assets/aural-author-3.png'),
  'aural-onboard-1.png': require('../../assets/aural-onboard-1.png'),
};

export function avatarSource(id?: string | null) {
  if (!id) return avatarOptions[0].source;

  return avatarOptions.find((item) => item.id === id)?.source
    ?? legacyAvatarMap[id]
    ?? avatarOptions[0].source;
}
